import type { CartOrderSummaryConfig } from '#types/config/components/cart/orderSummary'
import type { RecursivePartial } from '#types/utils'

export default {
  showCheckoutCta: false,
} satisfies RecursivePartial<CartOrderSummaryConfig>
